module.exports = __webpack_public_path__ + "static/tabliczka-b8d55ccc0d2d621b6b5666162c18c960.jpg";